import { Link, useParams, Navigate } from 'react-router-dom';
import PhotoPlaceholder from '../components/photo-placeholder';
import { CATS, TRAT } from '../data/services';
import { BUSINESS } from '../lib/business';
import { buildWhatsappUrl } from '../lib/whatsapp';
import { h1, pillButtonPrimary, pillButtonSecondary } from '../lib/styles';

const Category = () => {
  const { cat: catId } = useParams();
  const cat = CATS.find((c) => c.id === catId);
  const tratamientos = TRAT[catId] ?? [];

  if (!cat) return <Navigate to="/servicios" replace />;

  return (
    <div>
      <section style={{ background: '#FFF', borderBottom: '1px solid var(--ink-100)', padding: '4vw 5vw 5vw' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto' }}>
          <Link
            to="/servicios"
            style={{ fontSize: 12, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--ink-500)' }}
          >
            ← Servicios
          </Link>
          <div
            className="z-split-grid"
            style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '4vw', alignItems: 'center', marginTop: 20 }}
          >
            <div>
              <h1 style={{ ...h1, fontSize: 'clamp(36px, 6vw, 64px)', lineHeight: 1.05, margin: '0 0 16px' }}>
                {cat.nombre}
              </h1>
              <p
                style={{
                  fontSize: 16,
                  lineHeight: 1.75,
                  color: 'var(--ink-600)',
                  maxWidth: '50ch',
                  margin: '0 0 24px',
                }}
              >
                {cat.intro}
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                <Link to="/agendar" style={{ ...pillButtonPrimary, padding: '13px 24px' }}>
                  Agendar cita
                </Link>
                <a
                  href={buildWhatsappUrl(
                    BUSINESS.whatsapp,
                    `Hola Zenya, me interesa el área de ${cat.nombre}. ¿Tienen disponibilidad?`
                  )}
                  target="_blank"
                  rel="noreferrer"
                  style={{ ...pillButtonSecondary, padding: '13px 24px' }}
                >
                  Preguntar por WhatsApp
                </a>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {cat.fotos.map((f) => (
                <PhotoPlaceholder key={f} label={f} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '5vw', maxWidth: 1240, margin: '0 auto' }}>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 300,
            fontSize: 'clamp(26px, 3.8vw, 40px)',
            color: 'var(--ink-900)',
            margin: '0 0 3vw',
          }}
        >
          Tratamientos
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          {tratamientos.map((t) => (
            <article
              key={t.id}
              className="z-treatment-card"
              style={{
                background: '#FFF',
                border: '1px solid var(--ink-200)',
                borderRadius: 'var(--radius-xl)',
                boxShadow: 'var(--shadow-sm)',
                overflow: 'hidden',
                display: 'grid',
                gridTemplateColumns: '1fr',
              }}
            >
              <PhotoPlaceholder
                label={t.fotos[0]}
                style={{ borderRadius: 0, border: 'none', borderRight: '1px dashed var(--rose-200)', minHeight: 180 }}
              />
              <div style={{ padding: 26, display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 10,
                    alignItems: 'baseline',
                    justifyContent: 'space-between',
                  }}
                >
                  <h3
                    style={{
                      fontFamily: 'var(--font-display)',
                      fontWeight: 400,
                      fontSize: 28,
                      color: 'var(--ink-900)',
                      margin: 0,
                    }}
                  >
                    {t.nombre}
                  </h3>
                  <span style={{ fontFamily: 'var(--font-display)', fontSize: 26, color: 'var(--rose-700)' }}>
                    {t.precio}
                  </span>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  <span
                    style={{
                      fontSize: 11,
                      letterSpacing: '.12em',
                      textTransform: 'uppercase',
                      color: 'var(--ink-600)',
                      background: 'var(--ink-50)',
                      border: '1px solid var(--ink-200)',
                      borderRadius: 'var(--radius-pill)',
                      padding: '5px 12px',
                    }}
                  >
                    {t.duracion}
                  </span>
                  <span
                    style={{
                      fontSize: 11,
                      letterSpacing: '.12em',
                      textTransform: 'uppercase',
                      color: 'var(--rose-700)',
                      background: 'var(--rose-50)',
                      border: '1px solid var(--rose-200)',
                      borderRadius: 'var(--radius-pill)',
                      padding: '5px 12px',
                    }}
                  >
                    {t.etiqueta}
                  </span>
                </div>
                <p style={{ fontSize: 14.5, lineHeight: 1.7, color: 'var(--ink-600)', margin: 0 }}>{t.resumen}</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'center', marginTop: 2 }}>
                  <Link
                    to={`/servicios/${cat.id}/${t.id}`}
                    style={{
                      border: '1px solid var(--rose-300)',
                      background: 'transparent',
                      color: 'var(--rose-700)',
                      fontSize: 13,
                      letterSpacing: '.08em',
                      textTransform: 'uppercase',
                      padding: '11px 22px',
                      borderRadius: 'var(--radius-pill)',
                    }}
                  >
                    Ver detalle
                  </Link>
                  <a
                    href={buildWhatsappUrl(
                      BUSINESS.whatsapp,
                      `Hola Zenya, me interesa el servicio de ${t.nombre}. ¿Tienen disponibilidad?`
                    )}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      fontSize: 13,
                      letterSpacing: '.06em',
                      color: 'var(--ink-600)',
                      borderBottom: '1px solid var(--ink-300)',
                    }}
                  >
                    Preguntar por este servicio
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Category;
